export const AdminStructure = {
    DIVISION: 'DIVISION',
    DISTRICT: 'DISTRICT',
    TEHSIL: 'TEHSIL',
    MOUZA: 'MOUZA'
}